import React from "react";
import Form from "react-bootstrap/Form";
import clsx from "clsx";
import { useField } from "formik";
import { FormControlProps } from "react-bootstrap";
import { omit } from "lodash";
import { useIntl } from "react-intl";

interface SimpleFormControlProps {
    label?: string;
    name: string;
    type?: string;
    autoFocus?: boolean;
    cssClass?: string[];
    disabled?: boolean;
    maxLength?: number;
    min?: string | number;
    max?: string | number;
    [key: string]: any;
}

export const SimpleFormControl: React.FC<SimpleFormControlProps & FormControlProps> = (props) => {
    const {
        label,
        name,
        type = "string",
        autoFocus = false,
        cssClass,
        placeholder,
        min,
        max,
        disabled = false,
        maxLength,
    } = props;
    const [formikProps, meta] = useField(name);
    const { formatMessage } = useIntl();
    const value = formikProps.value === null ? undefined : formikProps.value;
    return (
        <div className="mb-2">
            {label && <Form.Label>{label}</Form.Label>}
            <Form.Control
                className={clsx(
                    cssClass || [],
                    {
                        "is-invalid": meta.touched && meta.error,
                    },
                    {
                        "is-valid": meta.touched && !meta.error,
                    }
                )}
                disabled={disabled}
                maxLength={maxLength}
                min={min}
                max={max}
                type={type}
                placeholder={placeholder}
                autoFocus={autoFocus}
                value={value}
                {...omit(formikProps, "value")}
                {...omit(props, "values")}
            />

            {meta.touched && meta.error && (
                <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                        <span role="alert">
                            {meta.error.includes("error.")
                                ? formatMessage({ id: meta.error })
                                : meta.error}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};
